import { AnimatePresence, motion } from 'motion/react';
import PropTypes from 'prop-types';

export default function Navigation({ children, keyProp }) {
	const animationInitialProps = { opacity: 0 };

	return (
		<AnimatePresence initial={false} mode="wait">
			<motion.nav
				key={keyProp}
				className="trial__navigation"
				initial={animationInitialProps}
				animate={{ opacity: 1 }}
				exit={animationInitialProps}
				transition={{ duration: 0.375 / 2 }}
			>
				{children}
			</motion.nav>
		</AnimatePresence>
	);
}

Navigation.propTypes = {
	children: PropTypes.node.isRequired,
	keyProp: PropTypes.string.isRequired,
};
